import {
  getBackendFeatureOverrideString,
  useBackendCookieFeatures,
  useBackendParamFeatures,
} from "./useBackendFeatures";

export function useBackendFeatureOverrideString() {
  // checks if `?backendFeatures` exists and adds any features to the feature cookie.
  // De-duplicate feature cookie before adding.
  const backendFeatureParam = useBackendParamFeatures();
  const featCookie = useBackendCookieFeatures();

  if (
    backendFeatureParam.length === 0 ||
    backendFeatureParam.every((f) => featCookie.includes(f))
  ) {
    return getBackendFeatureOverrideString(featCookie);
  }

  // Order here matters, features will be written left-to-right, overriding any previous values.
  const newFeatureCookie = getBackendFeatureOverrideString([
    ...featCookie,
    ...backendFeatureParam,
  ]);

  return newFeatureCookie;
}
